import { getCommonRequest, postCommonRequest } from "./axiosAction";
/** APIベースURL */
const API_BASE = `${process.env.APP_API_URL}j21spb32/layout-bulk-retrieve`;
/**
 * 取込処理を実行する
 * @param fileUuid タスクID(UUID)
 */
export async function requestImport(fileUuid) {
    const url = `${API_BASE}/import`;
    return await postCommonRequest(url, {
        fileUuid: fileUuid
    });
}
/**
 * 出力状況を取得する
 */
export async function fetchProgress() {
    const url = `${API_BASE}/progress`;
    const result = await getCommonRequest(url, false);
    if (result.data.statusCode !== 200) {
        const errorMessage = result.data.message || 'サーバーでエラーが発生しました';
        throw new Error(errorMessage);
    }
    return result.data.data.dataList;
}
/**
 * BOXからファイル取得 → ZIP化 → GCS保存
 * 件数はサーバー側の進捗管理テーブルから取得するため、fileUuidのみ送信する
 */
export async function requestCollect(fileUuid) {
    const url = `${API_BASE}/collect`;
    return await postCommonRequest(url, {
        fileUuid: fileUuid
    });
}
/**
 * 取込処理を中止する
 */
export async function requestCancel(fileUuid) {
    const url = `${API_BASE}/cancel`;
    return await postCommonRequest(url, {
        fileUuid: fileUuid
    });
}
